jQuery(document).ready(function(){

    if (jQuery('.main-nav > li > a > p').hasClass('green-text')) {
      jQuery('.main-nav > li > a > p').parent().addClass('green-text');
    }
  //



  jQuery(".faq-accordion-cntnt .accordion-header:first").addClass("active");
  jQuery(".faq-accordion-cntnt .accordion-content:first").addClass("active").slideDown();
  
  jQuery(".faq-accordion-cntnt .accordion-header").click(function() {
    if(jQuery(this).hasClass("active")) {
      jQuery(this).removeClass("active");
      jQuery(this).find(".icon").removeClass("active");
      jQuery(this).next().removeClass("active").slideUp();
    } else {
      jQuery(".faq-accordion-cntnt .accordion-header").removeClass("active");
      jQuery(".faq-accordion-cntnt .accordion-header .icon").removeClass("active");
      jQuery(".faq-accordion-cntnt .accordion-content").removeClass("active").slideUp();
      jQuery(this).addClass("active");
      jQuery(this).find(".icon").addClass("active");
      jQuery(this).next().addClass("active").slideDown();
    }
  });




});